export const palette = {
  white: '#fff',
  black: '#000',
  transparent: 'transparent',

  primary: {
    purple900: '#2b163f',
    purple800: '#381d53',
    purple700: '#48256b',
    purple600: '#5d2f89',
    purple500: '#663497',
    purple400: '#855dac',
    purple300: '#9877b9',
    purple200: '#b9a2cf',
    purple100: '#d0c0df',
    purple50: '#f0ebf5',
  },

  accent: {
    green900: '#385323',
    green800: '#496c2e',
    green700: '#5e8c3b',
    green600: '#79b34c',
    green500: '#85C553',
    green400: '#9dd175',
    green300: '#add88c',
    green200: '#c7e4b0',
    green100: '#d9edca',
    green50: '#f3f9ee',
  },

  background: {
    branded_purple: '#663497',
    general: '#D9E1FF',
    clear_white: '#ffffff',
    blue500: '#EDF1FF',
    unknown: '#EEEEEE',
  },

  text: {
    header_accent: '#663497',
    header_unknown: '#1D2433',
    value_unknown: '#666',
    header: '#2b163f',
    body: '#444444',
    placeholder: '#A9A9A9',
  },

  alerts: {
    error: '#942020',
    error_light: '#FFF1F1',
    success: '#85C553',
    success_light: '#F3F9EE',
  },

  border: {
    default: '#D8DBE8',
  },

  hover: {
    brand: '#5D2F89',
    background: '#F5EFFA',
  },

  color_system: {
    success_green: '#1B603B',
  },

  unknown: {
    disabled_grey: '#CCCCCC',
    sub_title_grey: '#666666',
    icon_grey: '#857F8B',
    checkbox_disabled_grey: '#AAAAAA',
  },
};
